import script from "./Tel.vue?vue&type=script&setup=true&lang=js"
export * from "./Tel.vue?vue&type=script&setup=true&lang=js"

import "./Tel.vue?vue&type=style&index=0&id=5785dddb&scoped=true&lang=scss"

import exportComponent from "/Users/vadimkholodov/Documents/GitHub/vahta-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5785dddb"]])

export default __exports__